import { computed, getCurrentScope, onScopeDispose, ref, toValue, watch } from 'vue'
import type { MaybeRefOrGetter } from 'vue'
import { LOADING_MESSAGES } from '@/config/loading-messages.config'
import type { LoadingContext } from '@/config/loading-messages.config'

const ROTATION_INTERVAL_MS = 2600

/**
 * Cycles through the loading-message pool for a context. Used by GlobalLoader
 * and PageLoader; the consuming component decides how the swap is animated
 * (the message itself changes regardless of prefers-reduced-motion — content
 * updates are information, not decoration).
 */
export function useLoadingMessages(context: MaybeRefOrGetter<LoadingContext> = 'generic') {
	const index = ref(0)
	const pool = computed<readonly string[]>(() => LOADING_MESSAGES[toValue(context)])
	const message = computed(() => pool.value[index.value % pool.value.length])

	const timer = setInterval(() => {
		index.value++
	}, ROTATION_INTERVAL_MS)

	// Restart the cycle from the first message when the context switches
	watch(pool, () => {
		index.value = 0
	})

	if (getCurrentScope()) {
		onScopeDispose(() => clearInterval(timer))
	}

	return { message }
}
